import classNames from 'classnames';
import React, { SyntheticEvent } from 'react';

import Button, { ButtonSizes, ButtonStyles } from '@Components/Buttons/Button';
import Icon, { IconSizes } from '@Components/Icon';

import styles from './ButtonFavorite.module.scss';

interface ButtonFavoriteProps {
  onChangeStatus: () => void;
  isFavorited?: boolean;
  withLabel?: boolean;
  size?: ButtonSizes;
  inPicture?: boolean;
}

const ButtonFavorite: React.FunctionComponent<ButtonFavoriteProps> = ({
  onChangeStatus,
  isFavorited,
  size = ButtonSizes.s,
  inPicture,
}) => {
  const handleStatusChange = (e: SyntheticEvent) => {
    e.stopPropagation();
    onChangeStatus();
  };

  return (
    <div className={classNames(styles.button, inPicture && styles.inPicture)}>
      <Button className={styles.padding} size={size} onClick={handleStatusChange} style={ButtonStyles.plain}>
        <div className={classNames(isFavorited ? styles.isFavorite : styles.isNotFavorite)}>
          <Icon icon={isFavorited ? 'heart-filled' : 'heart-empty'} size={IconSizes.s} />
        </div>
      </Button>
    </div>
  );
};

export default ButtonFavorite;
